export default __webpack_public_path__ + "media/megamenu-2.ce49f535.svg";